import { WidgetTitleProps } from '@/types/cms'
import SectionTitle from '@/components/SectionTitle/SectionTitle'
import AdLabel from '@/components/AdLabel/AdLabel'
import AppContext from '@/types/context'
import { isArticlePage } from '@/utils/app/detect'

export default function Title({ item, context }: Readonly<{ item: WidgetTitleProps; context: AppContext }>) {
  const useSectionName = item.model.fields?.useSectionName ?? true
  const title = item.model.fields?.title ?? ''
  const homeSection = item.items?.[0]?.model?.homeSection ?? ''

  return (
    <>
      {item.model.fields?.adLabel && <AdLabel />}
      <SectionTitle title={useSectionName ? homeSection : title} asHeadline={!isArticlePage(context.metadata)} />
    </>
  )
}
